import { LutienApi } from '@src/services/lutien/lutien-api';

const lutienApi = new LutienApi();

export async function getOrganizationsNames(): Promise<Record<string, string>> {
  try {
    const organizations = await lutienApi.v1.organizations.get();
    return organizations.reduce<Record<string, string>>((acc, org) => {
      acc[org.id] = org.fantasyName || org.corporateName || org.id;
      return acc;
    }, {});
  } catch (error) {
    console.error('Error fetching organizations:', error);
    return {};
  }
}
